import { render, staticRenderFns } from "./ContactClient.vue?vue&type=template&id=7b95b34c&scoped=true"
import script from "./ContactClient.vue?vue&type=script&lang=js"
export * from "./ContactClient.vue?vue&type=script&lang=js"
import style0 from "./ContactClient.vue?vue&type=style&index=0&id=7b95b34c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b95b34c",
  null
  
)

export default component.exports